import { render, staticRenderFns } from "./czOrder.vue?vue&type=template&id=320cc9fa&scoped=true"
import script from "./czOrder.vue?vue&type=script&lang=js"
export * from "./czOrder.vue?vue&type=script&lang=js"
import style0 from "./czOrder.vue?vue&type=style&index=0&id=320cc9fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320cc9fa",
  null
  
)

export default component.exports